import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import usePageTracking from './hooks/usePageTracking'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import Projects from './pages/Projects'
import ProjectDetail from './pages/ProjectDetail'
import Shop from './pages/Shop'
import Checkout from './pages/Checkout'
import PaymentResult from './pages/PaymentResult'
import Contact from './pages/Contact'
import Vacatures from './pages/Vacatures'
import Team from './pages/Team'
import Login from './pages/Login'
import Signup from './pages/Signup'
import Dashboard from './pages/Dashboard'
import AdminDashboard from './pages/Admin/AdminDashboard'
import './App.css'

const PageTracker = () => {
  usePageTracking();
  return null;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <PageTracker />
        <div className="app">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:id" element={<ProjectDetail />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/checkout/:orderId" element={<Checkout />} />
              <Route path="/payment/result" element={<PaymentResult />} />
              <Route path="/team" element={<Team />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/vacatures" element={<Vacatures />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/*"
                element={
                  <ProtectedRoute requireAdmin={true}>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>
          <Footer />
        </div>
      </AuthProvider>
    </Router>
  )
}

export default App
